<div class="drawing" [style.width.px]="width" [style.height.px]="height">
    <canvas id="canvasImage" #canvasImage></canvas>
    <canvas id="canvas" #canvas></canvas>
</div>
